import React from 'react'
import styles from './CommentThread.module.sass'
import FuseHighlight from 'components/FuseHighlight/FuseHighlight'

const CommentBody = ({ body, padded }) => {
	return (
		<div className={padded ? styles['padded'] : ''}>
			<small className={styles['comment-author']}>
				<p className={styles['comment-body']}>
					<FuseHighlight text={body} />
				</p>
			</small>
		</div>
	)
}

export default CommentBody
